module.exports = __webpack_public_path__ + "static/media/User-Outline.bc6e80bd.svg";